import React from 'react'
import FeatureGraphs from 'components/featureGraphs'
import RadarGraph from 'components/radarGraph'
import PredictedAge from 'components/predictedAge'
import './styles.scss'
import {
  SpotifyGetAuthUri,
  SpotifyAuthUser,
  SpotifyGetUserAge,
  SpotifyGetTop50Tracks,
  SpotifyGetTracksInfo
} from 'components/display/lib/spotify'
import {
  FirestoreWriteUserToDb,
  FirestoreHandleRunningAverage
} from 'components/display/lib/firestore'
import { handlePredictAge } from 'components/display/lib/predictAge'
import { Waypoint } from 'react-waypoint'
import Scrollchor from 'react-scrollchor'

const isMobile = window.innerWidth < 720

class Display extends React.Component {
  constructor(props) {
    super(props)

    // Check access token
    this.accessToken = SpotifyAuthUser()
    let loggedIn = this.accessToken !== ''

    // Set default state
    this.state = {
      loggedIn: loggedIn,
      expired: false,
      loading: true,
      appData: null
    }

    this.trackLogin = this.trackLogin.bind(this)
  }

  static defaultProps = {
    authorizeUrl: SpotifyGetAuthUri()
  }

  componentDidMount() {
    // access token present, get data from api, save to db
    if (this.state.loggedIn) {
      let app = {
        user: {
          accessToken: this.accessToken,
          age: 0,
          topTracks: [],
          featureProfile: {},
          predictedAge: 0
        },
        audioFeatures: [
          'popularity', // Popularität    = track.popularity
          'valence', // Fröhlichkeit    = track.features.valence
          'energy', // Energie        = track.features.energy
          'speechiness', // Sprachanteil   = track.features.speechiness
          'acousticness', // Akustikanteil = track.features.acousticness
          'liveness', // Liveanteil     = track.features.liveness
          'danceability', // Tanzbarkeit    = track.features.danceability
          'duration_ms' // Songdauer       = track.features.duration_ms
        ],
        alreadyPresent: false,
        runningCount: 0,
        runningAge: 0,
        runningAverage: {}
      }

      SpotifyGetUserAge(app)
        .catch(error => {
          if (error.status === 401) {
            this.setState({ expired: true })
          }
        })
        .then(SpotifyGetTop50Tracks)
        .then(SpotifyGetTracksInfo)
        .then(handlePredictAge)
        .then(FirestoreWriteUserToDb)
        .then(FirestoreHandleRunningAverage)
        .catch(error => {
          console.log('there was an error')
          console.log(error)
        })
        .then(app => this.setState({ loading: false, appData: app }))
    }
  }

  handleLogin = (loggedIn, expired) => {
    if (expired) {
      return (
        <div className='spotify-login'>
          <div className='ui grid horizontal segments connector'>
            <div className='ui middle aligned sixteen wide mobile ten wide tablet twelve wide computer column'>
              <p>
                Ihr Spotify-Token ist nicht mehr gültig, bitte melden Sie sich
                erneut an.
              </p>
            </div>
            <div className='ui middle aligned sixteen wide mobile six wide tablet four wide computer column'>
              <a
                href={this.props.authorizeUrl}
                onClick={this.trackLogin}
                className='fluid ui button right floated'
              >
                Anmelden
              </a>
            </div>
          </div>
        </div>
      )
    } else if (loggedIn) {
      return (
        <div className='spotify-login'>
          <div className='ui grid horizontal segments connector'>
            <div className='ui middle aligned sixteen wide mobile column'>
              <img
                src={require('./img/check.svg')}
                style={isMobile ? { width: '30%' } : { width: '17%' }}
              />
              <h4>Merci beaucoup!</h4>
              <p>
                Dans les graphiques ci-dessous, votre position est marquée par
                le point vert <i className='circle icon green' />.
              </p>
              <p>
                Le point bleu <i className='circle icon blue' />
                représente l'auditeur moyen.
              </p>
              <i className='icon big chevron down' />
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div className='spotify-login'>
          <div className='ui grid horizontal segments connector'>
            <div className='ui middle aligned sixteen wide mobile sixteen wide tablet sixteen wide computer column'>
              <div className='ui text container center aligned'>
                <img
                  src={require('./img/head.svg')}
                  style={isMobile ? { width: '35%' } : {}}
                />
              </div>
              <h4>Quels sont vos goûts musicaux?</h4>
              <p>
                Connectez-vous sur Spotify pour découvrir votre âge musical.
              </p>
            </div>
            <div
              className='ui center aligned sixteen wide mobile sixteen wide tablet sixteen wide computer column'
              style={{ padding: '0 0 2em' }}
            >
              <a
                href={this.props.authorizeUrl}
                onClick={this.trackLogin}
                className='ui button'
              >
                <strong>Se connecter</strong>
              </a>
            </div>
          </div>
        </div>
      )
    }
  }

  trackLogin() {
    /* eslint-disable */
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'connect to spotify'
    })
    /* eslint-enable */
  }

  render() {
    const loggedIn = this.state.loggedIn
    const expired = this.state.expired
    const appData = this.state.appData
    return (
      <>
        <div className='ui'>
          <div className='ui text container'>
            <div className='section-headers'>
              {this.handleLogin(loggedIn, expired)}
            </div>
          </div>
        </div>

        {/* Background */}
        <div className='ui background'>
          <div className='ui container'>
            <div className='section-headers'>
              <h3 className='ui header'>
                {this.state.loggedIn
                  ? 'Vos goûts musicaux comparés à ceux des autres utilisateurs'
                  : 'Les goûts musicaux des utilisateurs de Spotify'}
              </h3>
              <p style={{ paddingBottom: '1.5em' }}>
                Nous avons obtenu de Spotify les 100 chansons les plus écoutées
                de chaque génération. Les valeurs moyennes des différentes
                caractéristiques de ces chansons sont représentées par les
                lignes oranges <img src={require('./img/line.svg')} /> dans les
                graphiques ci-dessous. (
                <Scrollchor to='#methodik'>
                  <i
                    className='icon angle double down'
                    style={{ whiteSpace: 'nowrap' }}
                  />
                  En savoir plus sur la méthodologie
                </Scrollchor>
                ).
              </p>
            </div>
          </div>

          {/* Feature Graphs */}
          <div className='ui container featuregraphs'>
            <FeatureGraphs appData={this.state.loading ? false : appData} />
          </div>

          {/* Musikalisches Alter */}
          {appData ? (
            <>
              <div className='ui predictedage'>
                <div className='ui container section-headers'>
                  <h4 className='ui header'>Votre âge musical</h4>
                  <div className='subheader'>
                    Calculé à partir des propriétés de votre top100 sur Spotify
                  </div>
                </div>
                <PredictedAge appData={appData} />
              </div>
            </>
          ) : (
            ''
          )}

          {/* Radar Graph */}
          {appData ? (
            <>
              <div className='ui radargraph'>
                <div className='ui container section-headers'>
                  <h4 className='ui header'>Votre âge musical</h4>
                  <p className='radar-legende'>
                    <i className='circle icon green' />
                    Vous
                    <br />
                    <i className='circle icon blue' />
                    Auditeur moyen
                  </p>
                </div>
                <div className='ui text container'>
                  <RadarGraph appData={appData} />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          <Waypoint
            onEnter={event => {
              if (
                event.previousPosition === Waypoint.below &&
                event.currentPosition === Waypoint.inside
              ) {
                window.dataLayer = window.dataLayer || []
                /* eslint-disable */
                window.dataLayer.push({
                  event: 'Interactions',
                  event_action: 'vertical-scroll',
                  event_label: '75ContentRead'
                })
                /* eslint-enable */
              }
            }}
          />

          {/* Genres */}
          <div className='ui genres'>
            <div className='ui container section-headers'>
              <h4 className='ui header'>
                Les styles de musique préférés des générations
              </h4>
              <div className='subheader'>
                Pourcentage des chansons du top100 qui sont assignées au genre
                correspondant.
              </div>
            </div>
            <div className='ui container stackable two column grid'>
              <div className='column'>
                <img src={require('./img/rock-vs-rap.svg')} />
              </div>
              <div className='column'>
                <p>
                  Spotify classe ses chansons en dizaines de genres. Nous avons
                  filtré les quatre plus importants et les avons présentés selon
                  les préférences des générations. Le triomphe du rap dans la
                  jeune génération est frappant. Même la musique pop qui
                  dominait clairement auprès de toutes les générations
                  précédentes est aujourd'hui dépassée.
                </p>
              </div>
            </div>
          </div>

          {/* Playlists */}
          <div className='ui playlists'>
            <div className='ui container section-headers'>
              <h4 className='ui header'>
                Les 100 chansons les plus populaires des différentes générations
              </h4>
              <div className='subheader'>
                Les titres de morceaux les plus joués sur Spotify, avril 2018 à
                avril 2019
              </div>
            </div>
            <div className='ui container stackable two column grid'>
              <div className='column'>
                <iframe
                  src='https://open.spotify.com/embed/playlist/5Ch51C1nL0ZJUVNS3lBvK8'
                  width='100%'
                  height='380'
                  frameBorder='0'
                  allow='encrypted-media'
                />
              </div>
              <div className='column'>
                <iframe
                  src='https://open.spotify.com/embed/playlist/5lelOt4k5QfoTCnnp3ocp4'
                  width='100%'
                  height='380'
                  frameBorder='0'
                  allow='encrypted-media'
                />
              </div>
              <div className='column'>
                <iframe
                  src='https://open.spotify.com/embed/playlist/5YXuFfUzMRA83dhH6ojGee'
                  width='100%'
                  height='380'
                  frameBorder='0'
                  allow='encrypted-media'
                />
              </div>
              <div className='column'>
                <iframe
                  src='https://open.spotify.com/embed/playlist/07qSDB8jjjsANbhRwMlYBL'
                  width='100%'
                  height='380'
                  frameBorder='0'
                  allow='encrypted-media'
                />
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default Display
